export default __webpack_public_path__ + "static/media/Asset 4.d60f19f6.svg";